import { render, staticRenderFns } from "./promotionCard.vue?vue&type=template&id=55b9e8c8&scoped=true&"
import script from "./promotionCard.vue?vue&type=script&lang=js&"
export * from "./promotionCard.vue?vue&type=script&lang=js&"
import style0 from "./promotionCard.vue?vue&type=style&index=0&id=55b9e8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9e8c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b9e8c8')) {
      api.createRecord('55b9e8c8', component.options)
    } else {
      api.reload('55b9e8c8', component.options)
    }
    module.hot.accept("./promotionCard.vue?vue&type=template&id=55b9e8c8&scoped=true&", function () {
      api.rerender('55b9e8c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/components/promotionCard.vue"
export default component.exports